module.exports = __webpack_public_path__ + "img/new-marcas.12252df2.svg";